import { render, staticRenderFns } from "./VocabulariesList.vue?vue&type=template&id=d91db0fa&scoped=true"
import script from "./VocabulariesList.vue?vue&type=script&lang=js"
export * from "./VocabulariesList.vue?vue&type=script&lang=js"
import style0 from "./VocabulariesList.vue?vue&type=style&index=0&id=d91db0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91db0fa",
  null
  
)

export default component.exports